export const nwResult = {
    'result': {
      'alignments': [
        {
          'algn_a': 'CACCCCGATT-AA-GTGATATTGGAGATAGCT',
          'algn_b': 'GTATTGGCTTGAACCTGATGTGTGGGGTA--A',
          'identity': 0.4375,
          'path': [
            [
              30,
              30,
            ],
            [
              29,
              29,
            ],
            [
              28,
              29,
            ],
            [
              27,
              29,
            ],
            [
              26,
              28,
            ],
            [
              25,
              27,
            ],
            [
              24,
              26,
            ],
            [
              23,
              25,
            ],
            [
              22,
              24,
            ],
            [
              21,
              23,
            ],
            [
              20,
              22,
            ],
            [
              19,
              21,
            ],
            [
              18,
              20,
            ],
            [
              17,
              19,
            ],
            [
              16,
              18,
            ],
            [
              15,
              17,
            ],
            [
              14,
              16,
            ],
            [
              13,
              15,
            ],
            [
              12,
              14,
            ],
            [
              12,
              13,
            ],
            [
              11,
              12,
            ],
            [
              10,
              11,
            ],
            [
              10,
              10,
            ],
            [
              9,
              9,
            ],
            [
              8,
              8,
            ],
            [
              7,
              7,
            ],
            [
              6,
              6,
            ],
            [
              5,
              5,
            ],
            [
              4,
              4,
            ],
            [
              3,
              3,
            ],
            [
              2,
              2,
            ],
            [
              1,
              1,
            ],
          ],
        },
      ],
      'direction_matrix': [
        [
          [
            0,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            2,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
          [
            2,
            1,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            1,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            1,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            1,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
        ],
        [
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
        ],
        [
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            3,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
          [
            2,
          ],
          [
            2,
          ],
          [
            2,
            3,
          ],
          [
            2,
            3,
          ],
        ],
      ],
      'score': -12,
      'score_matrix': [
        [
          0,
          -3,
          -6,
          -9,
          -12,
          -15,
          -18,
          -21,
          -24,
          -27,
          -30,
          -33,
          -36,
          -39,
          -42,
          -45,
          -48,
          -51,
          -54,
          -57,
          -60,
          -63,
          -66,
          -69,
          -72,
          -75,
          -78,
          -81,
          -84,
          -87,
          -90,
        ],
        [
          -3,
          -1,
          -4,
          -7,
          -10,
          -13,
          -16,
          -19,
          -20,
          -23,
          -26,
          -29,
          -32,
          -35,
          -38,
          -41,
          -44,
          -47,
          -50,
          -53,
          -56,
          -59,
          -62,
          -65,
          -68,
          -71,
          -74,
          -77,
          -80,
          -83,
          -86,
        ],
        [
          -6,
          -4,
          -2,
          -3,
          -6,
          -9,
          -12,
          -15,
          -18,
          -21,
          -24,
          -27,
          -28,
          -31,
          -34,
          -37,
          -40,
          -43,
          -46,
          -49,
          -52,
          -55,
          -58,
          -61,
          -64,
          -67,
          -70,
          -73,
          -76,
          -79,
          -82,
        ],
        [
          -9,
          -7,
          -5,
          -3,
          -4,
          -7,
          -10,
          -13,
          -14,
          -17,
          -20,
          -23,
          -26,
          -29,
          -30,
          -33,
          -36,
          -39,
          -42,
          -45,
          -48,
          -51,
          -54,
          -57,
          -60,
          -63,
          -66,
          -69,
          -72,
          -75,
          -78,
        ],
        [
          -12,
          -10,
          -8,
          -6,
          -4,
          -5,
          -8,
          -11,
          -12,
          -15,
          -18,
          -21,
          -24,
          -27,
          -28,
          -29,
          -32,
          -35,
          -38,
          -41,
          -44,
          -47,
          -50,
          -53,
          -56,
          -59,
          -62,
          -65,
          -68,
          -71,
          -74,
        ],
        [
          -15,
          -13,
          -11,
          -9,
          -7,
          -5,
          -6,
          -9,
          -10,
          -13,
          -16,
          -19,
          -22,
          -25,
          -26,
          -27,
          -30,
          -33,
          -36,
          -39,
          -42,
          -45,
          -48,
          -51,
          -54,
          -57,
          -60,
          -63,
          -66,
          -69,
          -72,
        ],
        [
          -18,
          -16,
          -14,
          -12,
          -10,
          -8,
          -6,
          -7,
          -8,
          -11,
          -14,
          -17,
          -20,
          -23,
          -24,
          -25,
          -28,
          -31,
          -34,
          -37,
          -40,
          -43,
          -46,
          -49,
          -52,
          -55,
          -58,
          -61,
          -64,
          -67,
          -70,
        ],
        [
          -21,
          -17,
          -17,
          -15,
          -13,
          -11,
          -7,
          -5,
          -8,
          -9,
          -12,
          -13,
          -16,
          -19,
          -22,
          -25,
          -26,
          -27,
          -30,
          -33,
          -36,
          -39,
          -42,
          -45,
          -48,
          -51,
          -54,
          -57,
          -60,
          -63,
          -66,
        ],
        [
          -24,
          -20,
          -18,
          -16,
          -16,
          -14,
          -10,
          -8,
          -6,
          -9,
          -10,
          -13,
          -12,
          -15,
          -18,
          -21,
          -24,
          -27,
          -26,
          -29,
          -32,
          -35,
          -38,
          -41,
          -44,
          -47,
          -50,
          -53,
          -56,
          -59,
          -62,
        ],
        [
          -27,
          -23,
          -19,
          -19,
          -15,
          -15,
          -13,
          -11,
          -9,
          -5,
          -8,
          -11,
          -14,
          -13,
          -16,
          -19,
          -20,
          -23,
          -26,
          -25,
          -28,
          -31,
          -34,
          -37,
          -40,
          -43,
          -46,
          -49,
          -52,
          -55,
          -58,
        ],
        [
          -30,
          -26,
          -22,
          -20,
          -18,
          -14,
          -16,
          -14,
          -12,
          -8,
          -4,
          -7,
          -10,
          -13,
          -14,
          -17,
          -18,
          -21,
          -24,
          -25,
          -26,
          -27,
          -30,
          -33,
          -36,
          -39,
          -42,
          -45,
          -48,
          -51,
          -54,
        ],
        [
          -33,
          -29,
          -25,
          -21,
          -21,
          -17,
          -15,
          -17,
          -15,
          -11,
          -7,
          -5,
          -6,
          -9,
          -12,
          -15,
          -18,
          -19,
          -20,
          -23,
          -26,
          -27,
          -28,
          -31,
          -34,
          -37,
          -40,
          -43,
          -46,
          -47,
          -50,
        ],
        [
          -36,
          -32,
          -28,
          -24,
          -22,
          -20,
          -18,
          -16,
          -18,
          -14,
          -10,
          -8,
          -4,
          -5,
          -8,
          -11,
          -14,
          -17,
          -18,
          -21,
          -24,
          -27,
          -28,
          -29,
          -32,
          -35,
          -38,
          -41,
          -44,
          -45,
          -46,
        ],
        [
          -39,
          -35,
          -31,
          -27,
          -25,
          -23,
          -19,
          -17,
          -17,
          -17,
          -13,
          -9,
          -7,
          -5,
          -6,
          -9,
          -12,
          -13,
          -16,
          -19,
          -20,
          -23,
          -26,
          -29,
          -28,
          -31,
          -34,
          -37,
          -40,
          -43,
          -46,
        ],
        [
          -42,
          -38,
          -34,
          -30,
          -26,
          -24,
          -22,
          -20,
          -18,
          -16,
          -16,
          -12,
          -10,
          -8,
          -6,
          -7,
          -8,
          -11,
          -14,
          -15,
          -18,
          -19,
          -22,
          -25,
          -28,
          -29,
          -32,
          -35,
          -36,
          -39,
          -42,
        ],
        [
          -45,
          -41,
          -37,
          -33,
          -29,
          -27,
          -23,
          -21,
          -21,
          -19,
          -17,
          -15,
          -13,
          -11,
          -9,
          -7,
          -8,
          -7,
          -10,
          -13,
          -14,
          -17,
          -18,
          -21,
          -24,
          -27,
          -28,
          -31,
          -34,
          -37,
          -40,
        ],
        [
          -48,
          -44,
          -40,
          -36,
          -32,
          -30,
          -26,
          -24,
          -22,
          -22,
          -20,
          -18,
          -14,
          -12,
          -12,
          -10,
          -8,
          -9,
          -6,
          -9,
          -12,
          -15,
          -18,
          -19,
          -22,
          -25,
          -28,
          -29,
          -32,
          -33,
          -36,
        ],
        [
          -51,
          -47,
          -43,
          -39,
          -35,
          -31,
          -29,
          -27,
          -25,
          -21,
          -21,
          -21,
          -17,
          -15,
          -13,
          -13,
          -9,
          -9,
          -9,
          -5,
          -8,
          -11,
          -14,
          -17,
          -20,
          -23,
          -26,
          -29,
          -28,
          -31,
          -34,
        ],
        [
          -54,
          -50,
          -46,
          -42,
          -38,
          -34,
          -32,
          -30,
          -28,
          -24,
          -22,
          -22,
          -20,
          -16,
          -16,
          -14,
          -12,
          -10,
          -8,
          -8,
          -6,
          -9,
          -12,
          -15,
          -18,
          -21,
          -24,
          -27,
          -30,
          -27,
          -30,
        ],
        [
          -57,
          -53,
          -49,
          -45,
          -41,
          -37,
          -35,
          -33,
          -31,
          -27,
          -23,
          -23,
          -23,
          -19,
          -17,
          -17,
          -13,
          -13,
          -11,
          -7,
          -9,
          -5,
          -8,
          -11,
          -14,
          -17,
          -20,
          -23,
          -26,
          -29,
          -28,
        ],
        [
          -60,
          -56,
          -52,
          -48,
          -44,
          -40,
          -38,
          -36,
          -34,
          -30,
          -26,
          -24,
          -24,
          -22,
          -20,
          -18,
          -16,
          -14,
          -14,
          -10,
          -8,
          -8,
          -6,
          -7,
          -10,
          -13,
          -16,
          -19,
          -22,
          -25,
          -28,
        ],
        [
          -63,
          -59,
          -55,
          -51,
          -47,
          -43,
          -39,
          -37,
          -37,
          -33,
          -29,
          -25,
          -25,
          -25,
          -23,
          -21,
          -19,
          -15,
          -15,
          -13,
          -9,
          -9,
          -7,
          -7,
          -6,
          -9,
          -12,
          -15,
          -18,
          -21,
          -24,
        ],
        [
          -66,
          -62,
          -58,
          -54,
          -50,
          -46,
          -42,
          -38,
          -38,
          -36,
          -32,
          -28,
          -26,
          -26,
          -26,
          -24,
          -22,
          -18,
          -16,
          -16,
          -12,
          -10,
          -8,
          -8,
          -6,
          -5,
          -8,
          -11,
          -14,
          -17,
          -20,
        ],
        [
          -69,
          -65,
          -61,
          -57,
          -53,
          -49,
          -45,
          -41,
          -39,
          -39,
          -35,
          -31,
          -27,
          -25,
          -27,
          -27,
          -25,
          -21,
          -17,
          -17,
          -15,
          -13,
          -11,
          -9,
          -9,
          -7,
          -6,
          -9,
          -12,
          -13,
          -16,
        ],
        [
          -72,
          -68,
          -64,
          -60,
          -56,
          -52,
          -48,
          -44,
          -42,
          -40,
          -38,
          -34,
          -30,
          -28,
          -26,
          -28,
          -28,
          -24,
          -20,
          -18,
          -16,
          -16,
          -12,
          -12,
          -8,
          -8,
          -6,
          -5,
          -8,
          -11,
          -14,
        ],
        [
          -75,
          -71,
          -67,
          -63,
          -59,
          -55,
          -51,
          -47,
          -45,
          -43,
          -41,
          -37,
          -33,
          -29,
          -29,
          -27,
          -29,
          -27,
          -23,
          -21,
          -19,
          -17,
          -15,
          -13,
          -11,
          -9,
          -9,
          -7,
          -6,
          -7,
          -10,
        ],
        [
          -78,
          -74,
          -70,
          -66,
          -62,
          -58,
          -54,
          -50,
          -48,
          -44,
          -42,
          -40,
          -36,
          -32,
          -30,
          -30,
          -26,
          -29,
          -26,
          -22,
          -22,
          -18,
          -18,
          -14,
          -14,
          -12,
          -10,
          -10,
          -6,
          -7,
          -8,
        ],
        [
          -81,
          -77,
          -73,
          -69,
          -65,
          -61,
          -57,
          -53,
          -51,
          -47,
          -45,
          -43,
          -39,
          -35,
          -33,
          -31,
          -29,
          -27,
          -28,
          -25,
          -23,
          -21,
          -19,
          -17,
          -15,
          -15,
          -13,
          -11,
          -9,
          -5,
          -6,
        ],
        [
          -84,
          -80,
          -76,
          -72,
          -68,
          -64,
          -60,
          -56,
          -54,
          -50,
          -48,
          -44,
          -42,
          -38,
          -36,
          -34,
          -32,
          -28,
          -28,
          -28,
          -24,
          -24,
          -20,
          -20,
          -16,
          -14,
          -14,
          -12,
          -12,
          -8,
          -6,
        ],
        [
          -87,
          -83,
          -79,
          -75,
          -71,
          -67,
          -63,
          -59,
          -55,
          -53,
          -51,
          -47,
          -45,
          -41,
          -37,
          -35,
          -35,
          -31,
          -29,
          -29,
          -27,
          -25,
          -23,
          -21,
          -19,
          -17,
          -15,
          -15,
          -13,
          -11,
          -9,
        ],
        [
          -90,
          -86,
          -82,
          -78,
          -74,
          -70,
          -66,
          -62,
          -58,
          -54,
          -52,
          -50,
          -48,
          -44,
          -40,
          -38,
          -34,
          -34,
          -32,
          -28,
          -30,
          -26,
          -26,
          -22,
          -22,
          -20,
          -18,
          -16,
          -14,
          -14,
          -12,
        ],
      ],
    },
  };
export const paInput = {
    seqA: {
        seq: 'CAACGGCAGCTCACGAGGCCTAACCATATCACGCGA'+
        'GTGGCAAGTCACATTCCTGAGTCTCAACGAGTCAATTTCTAGACACATAGGGTC',
        range: [5, 30],
        name: 'sequence a',
    },
    seqB: {
        seq: 'ACTCAAGGCGGTCCTCAAATATGCCTGCCACAGCTAC'+
    'ACAGGTGTCTATTAAGTCGAGCGTACTCGTTCCACCGGCGCCGTAAAAACCGG',
        range: [5, 30],
        name: 'sequence b',
    },


};
// export const paInput = {
//     seqA: 'AAAA',
//     seqB: 'AAAG',
// };
